<template>
  <span :class="$style.sr">
    <slot />
  </span>
</template>

<style lang="scss" module>
.sr {
  @include sr-only();
}
</style>
